import { ConfigConstants } from './config';
import { fetchPost } from './fetchUtils';
import { storeSet, storeGet, storeRemove, storeSetCrossDomain } from './storeUtils';
import { reduxStore } from '../index';
import { BILLSBY_ADMIN_AUTH_DATA_CONTROL, BILLSBY_AUTH_DATA_CONTROL, BILLSBY_ONE_SESSION_LOGIN } from './constants';
import history from './history';
import { IToken } from '../models/Token';
import { initAuthData } from '../actions/authActions';

export function login(username: string, password: string, code2fa?: string) {
  return new Promise(function (fulfill: Function, reject: Function) {
    username = username.split('+').join('%2B');
    password = password.split('+').join('%2B');

    const data = JSON.stringify({ "grant_type": "password", username, password, code: code2fa });
    let url = `${ConfigConstants.baseUrl}token`;
    const headers = new Headers({ 'Content-Type': 'application/json', ClientId: ConfigConstants.clientId });

    fetchPost(url, headers, data)
      .then((response: any) => {
        response = <IToken>response;

        if (!reduxStore.getState().login.rememberUser) {
          // if the user doesn't check the remember user checkbox we save the token in the session storage
          //setStoreType(SESSION_STORAGE);
          storeSet(BILLSBY_ONE_SESSION_LOGIN, new Date());
        }

        // Store session data in browser local storage
        if(typeof response === "object") {
          storeSet(BILLSBY_ADMIN_AUTH_DATA_CONTROL, JSON.stringify(response));
          reduxStore.dispatch(initAuthData());
          history.push("/users");
        }

        fulfill(response);

      }).catch((error) => {
        reject(error);
      });
  });
}


export function logout() {
  storeRemove(BILLSBY_ADMIN_AUTH_DATA_CONTROL);
  reduxStore.dispatch(initAuthData());
  history.push("/login");
}


export function refreshToken(BILLSBY_AUTH_TOKEN_KEY: string, companyId: number) {
  return new Promise(function (fulfill: Function, reject: Function) {

    let storeData = storeGet(BILLSBY_AUTH_TOKEN_KEY);
    const data = JSON.stringify({ "grant_type": "refresh_token", "refresh_token": storeData.refresh_token, "company_id": companyId });
    let url = `${ConfigConstants.baseUrl}token`;
    const headers = new Headers({ 'Content-Type': 'application/json', ClientId: ConfigConstants.clientId });

    fetchPost(url, headers, data)
      .then((response: any) => {
        response = <IToken>response;
        // Store session data in browser local storage
        if(BILLSBY_AUTH_TOKEN_KEY === BILLSBY_AUTH_DATA_CONTROL) {
          storeSetCrossDomain(BILLSBY_AUTH_TOKEN_KEY, JSON.stringify(response));
        }
        else {
          storeSet(BILLSBY_AUTH_TOKEN_KEY, JSON.stringify(response));
        }
        reduxStore.dispatch(initAuthData());
        fulfill(response);

      }).catch((error) => {
        reject(error);
      });
  });
}